/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-detail[_ngcontent-%COMP%]{margin:16px 0}.close-icon[_ngcontent-%COMP%]{float:right}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/error.modal/error.handler.modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js